import { render, staticRenderFns } from "./HeadInfoSimple.vue?vue&type=template&id=059a2630"
import script from "./HeadInfoSimple.vue?vue&type=script&lang=js"
export * from "./HeadInfoSimple.vue?vue&type=script&lang=js"
import style0 from "./HeadInfoSimple.vue?vue&type=style&index=0&id=059a2630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports